import 'intersection-observer'

import headerScripts from './header'
import gmap from './gmap'
import {modalHandler} from './modals.js'
import animateScroll from './services'
import newsScripts from './news'

// check for IOS device
if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
    document.body.classList.add('ios-device')
}

jQuery($ => {
    
    headerScripts()
    modalHandler()
    newsScripts()
    animateScroll()
    
    if ($('section.map').length) {
        gmap(jQuery)
    }
    
    const inputFields = [].slice.apply(document.querySelectorAll('.input-field'))
    
    inputFields.map(input => {
        if (input.value) {
            input.classList.add('focused')
        }
        input.addEventListener('focus', () => addFocus(input))
        input.addEventListener('blur', () => removeFocus(input))
    })
    
    // INIT SLICK SLIDER
    jQuery('.quote__container').slick({
        autoplay: true,
        autoplaySpeed: 3000,
        dots: false,
        prevArrow: jQuery('.quote__arrows.left'),
        nextArrow: jQuery('.quote__arrows.right'),
    })
    
    //INIT LIGHT GALLERY
    const galleries = [].slice.apply(document.querySelectorAll('.wa-gallery'))
    if (galleries.length) {
        galleries.map(el => lightGallery(el))
    }
    
    // Contact form 7 on success submit functionality
    $('.wpcf7').each(function() {
        var $form = $(this)
        $form.on('wpcf7:mailsent', function(event) {
            $form.after('<div class="form-success"><div class="form-success__icon"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/></svg></div><span>Tack för ditt mail!</span></div>')
            $form.addClass('hidden')
            window.setTimeout(function() { $('.form-success').addClass('shown') }, 400)
        })
    })
    
    // columns tooltip mobile tweak
    $('.columns__grid-item').on('touch click', function(e) {
        const isTooltipClick = e.target.classList.contains('image-caption')
        if (isTooltipClick) {
            e.preventDefault()
        }
        
    })
})


//FORM focus animations
function addFocus(input) {
    input.parentNode.classList.add('focused')
}
function removeFocus(input) {
    !input.value ? input.parentNode.classList.remove('focused') : ''
}